import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { ReactElement } from "react";
import {
	AnnouncementCommentNotificationDataViewModel,
	AnnouncementCommentReactionNotificationDataViewModel
} from "client/Api/Notifications/notifications";
import { HubDetailsDialog } from "client/Features/Hub/HubDetailsDialog";

export type AnnouncementCommentActivityInvocationProps = {
	data: AnnouncementCommentNotificationDataViewModel
		| AnnouncementCommentReactionNotificationDataViewModel;
	onDismiss: () => void;
};

export const AnnouncementCommentActivityInvocation = (props: AnnouncementCommentActivityInvocationProps): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		announcementId,
		commentId
	} = data;

	return (
		<HubDetailsDialog
			itemKind={HubItemKind.Announcement}
			id={announcementId}
			commentId={commentId}
			onClose={onDismiss}
		/>
	);
};

AnnouncementCommentActivityInvocation.displayName = "AnnouncementCommentActivityInvocation";